import { useEffect, useState } from "react";

// @mui material components
import Card from "@mui/material/Card";
import Icon from "@mui/material/Icon";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import moment from "moment";
// Material Dashboard 2 React components
import MDAvatar from "components/MDAvatar";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

// API
import AddTransactionDrawer from "components/AddTransactionDrawer";
import { CardBody, Form } from "reactstrap";
import { GetAllUsersCall } from "../../../../redux/api/auth";

function Projects({ search = "" }) {
  console.log("pippo search", search);

  const [menu, setMenu] = useState(null);
  const [page, setPage] = useState(0);
  const [limit, setLimit] = useState(10);
  const [total, setTotal] = useState(0);
  const [user_id, set_user_id] = useState("");
  const [rows, setRows] = useState([]);
  const [openDrawer, setOpenDrawer] = useState(false);

  const fetchUsers = async (pageIndex = 0, pageSize = 10) => {
    const params = { page: pageIndex + 1, limit: pageSize, ...(search && { search }) };
    const response = await GetAllUsersCall(params);
    const allRows = response?.rows;
    const count = response?.total;
    if (allRows) {
      setTotal(count);
      setRows(allRows);
    }
  };

  useEffect(() => {
    fetchUsers(page, limit, search);
  }, [page, limit, search]);
  console.log("pippo rows", rows);

  const Author = ({ image, name, email, country }) => (
    <MDBox display="flex" alignItems="center" lineHeight={1}>
      {country && (
        <img
          src={`https://flagcdn.com/w40/${country.toLowerCase()}.png`}
          alt={country}
          style={{ width: 24, height: 16, marginRight: 8, borderRadius: 2 }}
        />
      )}
      <MDAvatar src={image || "https://ui-avatars.com/api/?name=" + name} name={name} size="sm" />
      <MDBox ml={2} lineHeight={1}>
        <MDTypography display="block" variant="button" fontWeight="medium">
          {name}
        </MDTypography>
        <MDTypography variant="caption">{email}</MDTypography>
      </MDBox>
    </MDBox>
  );

  // const openMenu = ({ currentTarget }) => {
  //   console.log("pippo currentTarget", currentTarget);

  //   setMenu(currentTarget);
  // };
  // const closeMenu = () => setMenu(null);

  // const renderMenu = (
  //   <Menu
  //     id="simple-menu"
  //     anchorEl={menu}
  //     anchorOrigin={{ vertical: "top", horizontal: "left" }}
  //     transformOrigin={{ vertical: "top", horizontal: "right" }}
  //     open={Boolean(menu)}
  //     onClose={closeMenu}
  //   >
  //     <MenuItem onClick={() => setOpenDrawer(true)}>Add Subscription</MenuItem>
  //     <MenuItem onClick={closeMenu}>More Info</MenuItem>
  //   </Menu>
  // );

  return (
    <Card>
      <MDBox display="flex" justifyContent="space-between" alignItems="center" p={3}>
        <MDBox>
          <MDTypography variant="h6" gutterBottom>
            Microlab Users
          </MDTypography>
          <MDBox display="flex" alignItems="center" lineHeight={0}>
            <Icon
              sx={{ fontWeight: "bold", color: ({ palette: { info } }) => info.main, mt: -0.5 }}
            >
              done
            </Icon>
            <MDTypography variant="button" fontWeight="regular" color="text">
              &nbsp;<strong>{total} users</strong> total
            </MDTypography>
          </MDBox>
        </MDBox>
        {/* <MDBox color="text" px={2}>
          <Icon sx={{ cursor: "pointer", fontWeight: "bold" }} fontSize="small" onClick={openMenu}>
            more_vert
          </Icon>
        </MDBox> */}
        {/* {renderMenu} */}
      </MDBox>

      <TableContainer>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Name</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map((user, index) => (
              <TableRow key={index}>
                <TableCell>
                  <Author
                    image={user.profile_image}
                    name={`${user.first_name} ${user.last_name}`}
                    email={user.email}
                    country={user?.country}
                  />
                </TableCell>
                <TableCell>{user.status}</TableCell>
                <TableCell>{user.role}</TableCell>
                <TableCell>{user.university}</TableCell>
                <TableCell>{moment(user.created_at).format("YY/MM/DD HH:mm")}</TableCell>
                <TableCell>{moment(user.updated_at).format("YY/MM/DD HH:mm")}</TableCell>
                <TableCell>
                  {" "}
                  <MDBox color="text" px={2}>
                    <Icon
                      sx={{ cursor: "pointer", fontWeight: "bold" }}
                      fontSize="small"
                      onClick={() => {
                        // openMenu();
                        setOpenDrawer(true);
                        set_user_id(user?.id);
                      }}
                    >
                      more_vert
                    </Icon>
                  </MDBox>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
        <CardBody>
          <Form>
            <div id={"map"} style={{ width: "100%", height: "70vh" }} />
            <AddTransactionDrawer
              user_id={user_id}
              open={openDrawer}
              toggleDrawer={setOpenDrawer}
            />
          </Form>
        </CardBody>
      </TableContainer>

      <TablePagination
        component="div"
        count={total}
        page={page}
        onPageChange={(event, newPage) => setPage(newPage)}
        rowsPerPage={limit}
        onRowsPerPageChange={(event) => {
          setLimit(parseInt(event.target.value, 10));
          setPage(0);
        }}
        rowsPerPageOptions={[5, 10, 15, 20]}
      />
    </Card>
  );
}

export default Projects;
